// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"cb406d1b","688":"0b633ccc","963":"450927d7"}[chunkId] + ".chunk.css";
};